import audit from './audit';

export default {
  namespaced: true,
  modules: {
    audit,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/audit/index.js